import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { Its2Constants } from '@apps/its2/its2.constants';
import { OpenPopinOriginator } from '@common/enum/open-popin-originator.enum';

@Component({
    selector: 'aa-service',
    templateUrl: './service.component.html',
    styleUrls: [
        './service.component.scss'
    ],
    standalone: false
})
export class ServiceComponent
{
    @Input() openPopinOriginator: OpenPopinOriginator;
    @Input() commands: any[];

    constructor (
        private router: Router
    )
    { }

    createService ()
    {
        const route = this.commands ?? Its2Constants.CreateServiceRoute(this.openPopinOriginator);

        this.router.navigate(route);
    }
}
